import React from 'react';
import { Menu, Transition } from "@headlessui/react";
import { usePopper } from "react-popper";
import { useRef, useState } from "react";
import { bottom } from "@popperjs/core";
import { Link } from 'react-router-dom';
import Image from '../components/elements/Image';

const NotificationDropdown = ({ xPlacement, ...props }) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const placements = {
    left: "bottom-start",
    right: "bottom-end",
    "": bottom,
  };

  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 8],
        },
      },
    ],
  });

  const dropdownData = [
    {
      _id:1, 
      user: "Sujan Dey", 
      image: "https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8dXNlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: true
    },
    {
      _id:2, 
      user: "Sujay Mondal", 
      image: "https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8dXNlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: true
    },
    {
      _id:3, 
      user: "Subhajit Saha", 
      image: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTN8fHVzZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: true
    },
    {
      _id:4, 
      user: "Chinmoy Ghosh", 
      image: "https://images.unsplash.com/photo-1530268729831-4b0b9e170218?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NDF8fHVzZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: false
    },
    {
      _id:5, 
      user: "Soumya Ghosh", 
      image: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzV8fHVzZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: false
    },
    {
      _id:6, 
      user: "Madhumita Maity", 
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8dXNlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: false
    },
    {
      _id:7, 
      user: "Animesh Manna", 
      image: "https://images.unsplash.com/photo-1544168190-79c17527004f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MzJ8fHVzZXJ8ZW58MHx8MHx8&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: false
    },
    {
      _id:8, 
      user: "Sangita Manna", 
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8dXNlcnxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60",
      text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.", 
      date: "16 Nov 2022", 
      link: "/",
      isUnread: false
    },
  ]


  return (
    <>
      <Menu as="div">
        {({ open }) => (
          <>
            <Menu.Button ref={setTargetElement} className="flex items-center">
              <div className="relative w-10 h-10 flex items-center justify-center focus:ring-0 transition-all duration-200">
                {dropdownData.filter((item) => (item.isUnread)).length > 0 &&
                <div className="absolute top-0 right-1 z-10 bg-blue-500 text-white text-[9px] w-4 h-4 rounded-full flex justify-center items-center leading-none">{dropdownData.filter((item) => (item.isUnread)).length}</div>
                }
                <div className="text-xl text-slate-400">
                  <i className="fa-regular fa-fw fa-bell"></i>
                </div>
              </div>
            </Menu.Button>
            <Transition
              show={open}
              leave="transition duration-75" leaveFrom="opacity-100" leaveTo="opacity-0" className="z-50"
              beforeEnter={() => setPopperElement(popperElRef.current)}
              afterLeave={() => setPopperElement(null)}
              ref={popperElRef}
              style={styles.popper}
              {...attributes.popper}
            >
              <Menu.Items className="w-96 origin-top-right bg-white border-0 divide-y divide-slate-200 rounded-md shadow ring-0">
                <div className="relative px-3 py-2 text-base font-bold text-slate-800">Notification</div>
                <div className="py-1 max-h-80 divide-y divide-slate-100 overflow-auto scroll-smooth scrollbar">
                  {dropdownData.map((item) => (
                    <Link to={item.link} className={"group flex py-2 px-3 gap-3 transition-all duration-200 hover:bg-slate-100 " + (item.isUnread?'bg-slate-50':'')} key={item._id}>
                      <div className={"w-10 h-10 min-w-[40px] overflow-hidden rounded-full ring-1 ring-offset-2 " + (item.isUnread?'ring-blue-500':'ring-slate-200')}>
                        <Image src={item.image} alt={item.user} width={'100%'} height={'100%'} effect={'blur'} classes={'object-cover'}/>
                      </div>
                      <div className="w-full relative flex flex-col gap-1">
                        <div className="text-sm font-bold text-slate-700 leading-tight">{item.user}</div>
                        <div className="text-xs text-slate-500 leading-tight">{item.text}</div>
                        <div className={"text-[11px] leading-tight " + (item.isUnread?'text-slate-400':'text-slate-300')}>{item.date}</div>
                      </div>
                    </Link>
                  ))}
                </div>
                <div className="relative px-3 py-3 flex justify-center items-center">
                  <Menu.Item>
                    <Link to={'/notification'} className="text-sm font-semibold text-slate-500 hover:text-blue-500 hover:underline underline-offset-1 transition-all duration-200">See all notifications</Link>
                  </Menu.Item>
                </div>
              </Menu.Items>
            </Transition>
          </>
        )}
      </Menu>
    </>
  );
};

export default NotificationDropdown;